module.exports = __webpack_public_path__ + "50e01fd037120e13ce24411163661eab.pdf";